import { ChangeDetectorRef, Component, Inject, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { MappingEntityInterface } from './mapping-entity.interface';
import { MappingPageComponent } from './mapping-page.component';
import { MappingServiceInterface } from './mapping-service.interface';
import { MappingFilterEntityServiceInterface } from './mapping-filter-entity-service.interface';
import { Observable } from 'rxjs';

@Component({
  selector: 'hcre-mapping-component-base',
  template: ''
})
export abstract class MappingComponentBase {
    @ViewChild(MappingPageComponent) protected mappingComponent: MappingPageComponent;
    @ViewChild('mappingForm', { static: false }) public mappingForm: NgForm;
  
    public abstract getDisplayName(mapping: MappingEntityInterface): string; 
    public abstract getDisplayTitle(mapping: MappingEntityInterface): string;    

  constructor(@Inject('MappingServiceInterface') protected _mappingService: MappingServiceInterface,
    protected _changeDetector: ChangeDetectorRef,
    @Inject('MappingFilterEntityServiceInterface') protected _mappingClientService?: MappingFilterEntityServiceInterface) {
  }

    // Prevent "Expression has changed after it was checked" error
    ngAfterViewChecked(): void {
        this._changeDetector.detectChanges();
    }

    GetRecentSelectedFilterEntityId() {
        let recentSelectedFilterEntityId = sessionStorage.getItem('RecentSelectedFilterEntityId');
        if (recentSelectedFilterEntityId)
            return Number(recentSelectedFilterEntityId);
        return -1;
    }

    canDeactivate(): boolean | Observable<boolean> | Promise<boolean> {
        return this.mappingComponent.canDeactivate();
    }
}
